import request from "@/utils/request";

export const getProductionApi = (data) =>
  request({
    url: `/api/V2/production?${data}`,
    method: "get",
  });

export const productionTopApi = (data) =>
  request({
    url: "/api/V2/production/top",
    method: "post",
    data,
  });

export const productionAssignApi = (data) =>
  request({
    url: "/api/V2/production/assign",
    method: "post",
    data,
  });

export const productionEstimateApi = () =>
  request({
    url: `/api/V2/production-estimate`,
    method: "get",
  });

export const productionEstimateSettingsApi = (data) =>
  request({
    url: "/api/V2/production-estimate/settings",
    method: "post",
    data,
  });
export const autoRunStatusApi = (data) =>
  request({
    url: "/api/V2/autorun",
    method: "get",
    data,
  });
export const autoRunStartApi = (data) =>
  request({
    url: "/api/V2/autorun/start",
    method: "post",
    data,
  });

export const autoRunStopApi = (data) =>
  request({
    url: "/api/V2/autorun/stop",
    method: "post",
    data,
  });

export const autoRunPauseApi = (data) =>
  request({
    url: "/api/V2/autorun/pause",
    method: "post",
    data,
  });

export const autoRunResumeApi = (data) =>
  request({
    url: "/api/V2/autorun/resume",
    method: "post",
    data,
  });

export const autoRunTemplatesApi = () =>
  request({
    url: "/api/V2/autorun/templates",
    method: "get",
  });

export const autoRunAckApi = (data) =>
  request({
    url: "/api/V2/autorun/ack",
    method: "post",
    data,
  });
